import { ESellerStatus } from './seller'

// SignUp
export interface ITokensResponse extends Components.Schemas.ITokensResponse {}
export interface ISignUpRequest extends Components.Schemas.ISignUpRequest {
  personal_data_consent: boolean
}
export interface ISignUpResponse extends Components.Schemas.ISignUpResponse {}
export interface ISignUpAppleRequest extends Components.Schemas.ISignUpAppleRequest {}
export interface ISignUpAppleResponse extends Components.Schemas.ISignUpAppleResponse {}
export interface ISignUpGoogleRequest extends Components.Schemas.ISignUpGoogleRequest {}
export interface ISignUpGoogleResponse extends Components.Schemas.ISignUpGoogleResponse {}
export interface ISignUpVkRequest extends Components.Schemas.ISignUpVkRequest {}
export interface ISignUpVkResponse extends Components.Schemas.ISignUpVkResponse {}
export interface IGenerateTokenRequest extends Components.Schemas.GenerateTokenRequestDto {}
export interface IGenerateTokenResponse extends Components.Schemas.GenerateTokenResponseDto {}
export interface IActivationRequest
  extends Components.Schemas.IActivationRequest {}
export interface ICreateSellerRequest
  extends Components.Schemas.ICreateSellerRequest {}
export interface ICreatePhysicalSellerRequest
  extends Components.Schemas.ICreatePhysicalSellerRequest {}

// SignIn
export interface ISignInRequest extends Components.Schemas.ILoginRequest {}
export interface ISignInResponse extends Components.Schemas.ILoginResponse {}
export interface IRefreshResponse extends Components.Schemas.IRefreshResponse {}
export enum ELoginTypes {
  SELLER = 'SELLER',
  USER = 'USER'
}

// Recovery Password
export interface ISendEmailRequest extends Components.Schemas.ISendEmailRequest {}
export interface IVerifyPasswordRecoveryCodeRequest {
  email: string
  activation_code: number
}
export interface IVerifyPasswordRecoveryCodeResponse {
  password_recovery_token: string
  expires_in_seconds: number
}
export interface IRecoveryRequest {
  password_recovery_token: string
  password: string
}

// User
export enum ERoles {
  ADMIN = 'ADMIN',
  USER = 'USER'
}
export interface ITokenParseUser {
  _id: string
  email: string
  role: ERoles
  isActivated: boolean
  seller_id?: string
  seller_status?: ESellerStatus
  // у сотрудника магазина seller_id — магазин работодателя
  employee_id?: string
  exp: number
  iat: number
}

// Подтверждение телефона
export interface ISendPhoneCodeRequest {
  phone: number
}
export interface ISendPhoneCodeResponse {
  message: string
  expires_in_seconds?: number
  is_phone_verified?: boolean
}
export interface IVerifyPhoneRequest {
  code: number
}
export interface IVerifyPhoneResponse {
  message: string
  phone: number
  is_phone_verified: boolean
}

// Вход по телефону (.AUTH_RULES.md §2)
export interface IRequestPhoneLoginRequest {
  phone: string | number
  type?: ELoginTypes
}
export interface IRequestPhoneLoginResponse {
  phone_login_token: string
  phone_verification_code_sent?: boolean
  requires_email_confirmation?: boolean
  message: string
}
export interface IVerifyPhoneLoginRequest {
  phone_login_token: string
  code: number
}
export interface IPhoneLoginTokensResponse extends ITokensResponse {
  user_id: string
  isSeller: boolean
  role: ERoles
  is_phone_verified: boolean
  phone: number
  message: string
}
// SMS верна, но номер в аккаунте не подтверждён: до входа просят код с почты
export interface IPhoneLoginEmailStepResponse {
  requires_email_confirmation: true
  // почту вводит человек, когда номер записан в нескольких аккаунтах
  email_required: boolean
  email_mask?: string
  email_code_sent?: boolean
  can_detach_email: boolean
  phone_login_token: string
  message: string
}
export type IVerifyPhoneLoginResponse =
  | IPhoneLoginTokensResponse
  | IPhoneLoginEmailStepResponse

export const isPhoneLoginEmailStep = (
  response: IVerifyPhoneLoginResponse
): response is IPhoneLoginEmailStepResponse =>
  'requires_email_confirmation' in response &&
  response.requires_email_confirmation === true

export interface IResendPhoneLoginRequest {
  phone_login_token: string
}
export interface IRequestPhoneLoginEmailCodeRequest {
  phone_login_token: string
  email?: string
}
export interface IRequestPhoneLoginEmailCodeResponse {
  email_mask: string
  can_detach_email: boolean
  phone_login_token: string
  expires_in_seconds: number
  message: string
}
export interface IVerifyPhoneLoginEmailCodeRequest {
  phone_login_token: string
  code: number
  email?: string
}

// Подтверждение почты (.AUTH_RULES.md §7)
export interface IRequestEmailAttachCodeRequest {
  email: string
}
export interface IRequestEmailAttachCodeResponse {
  email: string
  expires_in_seconds: number
  message: string
}
export interface IVerifyEmailAttachCodeRequest {
  code: number
}
export interface IVerifyEmailAttachCodeResponse {
  user_id: string
  email: string
  is_activated: boolean
  merged: boolean
  message: string
}

// Checking
export interface ICheckSellerDataForCorrectness extends Components.Schemas.ICheckSellerDataForCorrectness {}
export enum ECheckSellerDataErrors {
  'INVALID_PASSPORT' = 'INVALID_PASSPORT',
  'INCORRECT_INN' = 'INCORRECT_INN',
  'INN_NOT_FOUND' = 'INN_NOT_FOUND',
}
